// import React, { useEffect, useMemo, useState } from "react";
// import "../Assests/Tickets.css";
// import { getAllProjects } from "../Db_Connections/projectsApi";
// import {
//     getAllTickets,
//     getTicketsByAssignee,
//     setTicketReady,
//     closeTicket,
// } from "../Db_Connections/ticketsApi";
// import TaskModal from "./TaskModal";

// export default function Tickets({ auth }) {
//     const user = auth || JSON.parse(sessionStorage.getItem("auth"));
//     const isAdmin = user?.role === "Admin" || user?.role === "Super Admin";

//     const [projects, setProjects] = useState([]);
//     const [tickets, setTickets] = useState([]);
//     const [loading, setLoading] = useState(true);

//     const [showTaskModal, setShowTaskModal] = useState(false);

//     const loadAll = async () => {
//         setLoading(true);

//         const projRes = await getAllProjects();
//         if (projRes.error) console.error(projRes.error);
//         setProjects(projRes.data || []);

//         const ticketRes = isAdmin
//             ? await getAllTickets()
//             : await getTicketsByAssignee(user?.email);

//         if (ticketRes.error) console.error(ticketRes.error);
//         setTickets(ticketRes.data || []);

//         setLoading(false);
//     };

//     useEffect(() => {
//         loadAll();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [isAdmin]);

//     const projectMap = useMemo(() => {
//         const m = {};
//         (projects || []).forEach((p) => (m[p.id] = p));
//         return m;
//     }, [projects]);

//     // cards: per project total/complete/pending (complete = is_closed)
//     const projectCards = useMemo(() => {
//         const byProject = {};
//         (tickets || []).forEach((t) => {
//             const pid = t.project_id;
//             if (!pid) return;
//             if (!byProject[pid]) byProject[pid] = [];
//             byProject[pid].push(t);
//         });

//         return Object.keys(byProject).map((pidStr) => {
//             const pid = Number(pidStr);
//             const list = byProject[pid] || [];
//             const total = list.length;
//             const completed = list.filter((x) => !!x.is_closed).length;
//             const pending = total - completed;

//             return {
//                 projectId: pid,
//                 projectName: projectMap[pid]?.name || `Project (${pid})`,
//                 total,
//                 completed,
//                 pending,
//             };
//         });
//     }, [tickets, projectMap]);

//     const recentTasks = useMemo(() => (tickets || []).slice(0, 12), [tickets]);

//     const toggleReady = async (t) => {
//         const { error } = await setTicketReady(t.ticket_id, !t.status);
//         if (error) return alert(error.message);
//         loadAll();
//     };

//     const closeMyTicket = async (t) => {
//         const ok = window.confirm("Close this ticket?");
//         if (!ok) return;

//         const { error } = await closeTicket(t.ticket_id);
//         if (error) return alert(error.message);
//         loadAll();
//     };

//     return (
//         <div className="tk-container">
//             <div className="tk-header">
//                 <h2 className="tk-title">Tickets</h2>

//                 {isAdmin && (
//                     <button className="tk-assign-btn" onClick={() => setShowTaskModal(true)}>
//                         Task
//                     </button>
//                 )}
//             </div>

//             {loading ? (
//                 <p>Loading...</p>
//             ) : (
//                 <>
//                     <div className="tk-cards">
//                         {projectCards.length === 0 ? (
//                             <div className="tk-empty">No tasks found.</div>
//                         ) : (
//                             projectCards.map((c) => (
//                                 <div className="tk-card" key={c.projectId}>
//                                     <div className="tk-card-title">{c.projectName}</div>

//                                     <div className="tk-stats">
//                                         <div className="tk-row">
//                                             <span className="tk-label">Total Task</span>
//                                             <span className="tk-value">{c.total}</span>
//                                         </div>
//                                         <div className="tk-row">
//                                             <span className="tk-label">Complete Task</span>
//                                             <span className="tk-value green">{c.completed}</span>
//                                         </div>
//                                         <div className="tk-row">
//                                             <span className="tk-label">Pending Task</span>
//                                             <span className="tk-value orange">{c.pending}</span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             ))
//                         )}
//                     </div>

//                     <div className="tk-list-section">
//                         <div className="tk-list-header">
//                             <span className="tk-list-title">{isAdmin ? "Recent Tasks" : "My Tasks"}</span>
//                         </div>

//                         {recentTasks.length === 0 ? (
//                             <div className="tk-empty">No tasks found.</div>
//                         ) : (
//                             <div className="tk-task-list">
//                                 {recentTasks.map((t) => {
//                                     const projectName = projectMap[t.project_id]?.name || "-";
//                                     const dateStr = t.created_at
//                                         ? new Date(t.created_at).toLocaleDateString()
//                                         : "-";

//                                     return (
//                                         <div className="tk-task-card" key={t.ticket_id}>
//                                             <div className="tk-task-left">
//                                                 <div className="tk-task-name">{t.title}</div>
//                                                 <div className="tk-task-sub">
//                                                     TASK-{t.ticket_id} • {projectName} • {dateStr}
//                                                     {t.file_name ? ` • File: ${t.file_name}` : ""}
//                                                 </div>
//                                             </div>

//                                             <div className="tk-task-right">
//                                                 {/* Ready status */}
//                                                 <span className={`tk-status ${t.status ? "ready" : "notready"}`}>
//                                                     {t.status ? "True" : "False"}
//                                                 </span>

//                                                 {/* Closed badge */}
//                                                 {t.is_closed && <span className="tk-status closed">Closed</span>}

//                                                 {/* Admin toggle */}
//                                                 {isAdmin && !t.is_closed && (
//                                                     <button className="tk-mini-btn" onClick={() => toggleReady(t)}>
//                                                         {t.status ? "Set False" : "Set True"}
//                                                     </button>
//                                                 )}

//                                                 {/* User close button (only when ready=true and not closed) */}
//                                                 {!isAdmin && t.status === true && !t.is_closed && (
//                                                     <button className="tk-mini-btn primary" onClick={() => closeMyTicket(t)}>
//                                                         Close Ticket
//                                                     </button>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         )}
//                     </div>
//                 </>
//             )}

//             {isAdmin && showTaskModal && (
//                 <TaskModal
//                     auth={auth}
//                     projects={projects}
//                     onClose={() => setShowTaskModal(false)}
//                     onSaved={() => {
//                         setShowTaskModal(false);
//                         loadAll();
//                     }}
//                 />
//             )}
//         </div>
//     );
// }
import React, { useEffect, useMemo, useState } from "react";
import "../Assests/Tickets.css";
import TaskDetailsModal from "../Components/TaskDetailsModal";
import { getAllProjects } from "../Db_Connections/projectsApi";
import {
    getAllTickets,
    getTicketsByAssignee,
    setTicketReady,
    closeTicket,
} from "../Db_Connections/ticketsApi";
import TaskModal from "./TaskModal";

export default function Tickets({ auth }) {
    const user = auth || JSON.parse(sessionStorage.getItem("auth"));
    console.log("user from session",user);
    
    const isAdmin = user?.role === "Admin" || user?.role === "Super Admin" || user?.role === "Manager";
    

    const [projects, setProjects] = useState([]);
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [errorMsg, setErrorMsg] = useState("");

    const [showTaskModal, setShowTaskModal] = useState(false);
    const [editingTicket, setEditingTicket] = useState(null);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [viewingTicket, setViewingTicket] = useState(null);

    const openDetailsModal = (t) => {
        console.log("OPEN DETAILS", t);   // ✅ test
        setViewingTicket(t);
        setShowDetailsModal(true);
    };

    const loadAll = async () => {
        setLoading(true);

        const projRes = await getAllProjects();
        if (projRes.error) console.error(projRes.error);
        setProjects(projRes.data || []);

        const ticketRes = isAdmin
            ? await getAllTickets()
            : await getTicketsByAssignee(user?.email);

        if (ticketRes.error) console.error(ticketRes.error);
        setTickets(ticketRes.data || []);

        setLoading(false);
    };

    useEffect(() => {
        loadAll();

        const interval = setInterval(loadAll, 120000); 

        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAdmin]);
    

    const projectMap = useMemo(() => {
        const m = {};
        (projects || []).forEach((p) => (m[p.id] = p));
        return m;
    }, [projects]);

    const projectCards = useMemo(() => {
        const byProject = {};
        (tickets || []).forEach((t) => {
            const pid = t.project_id;
            if (!pid) return;
            if (!byProject[pid]) byProject[pid] = [];
            byProject[pid].push(t);
        });

        return Object.keys(byProject).map((pidStr) => {
            const pid = Number(pidStr);
            const list = byProject[pid] || [];
            const total = list.length;
            const completed = list.filter((x) => !!x.is_closed).length;
            const pending = total - completed;

            return {
                projectId: pid,
                projectName: projectMap[pid]?.name || `Project (${pid})`,
                total,
                completed,
                pending,
            };
        });
    }, [tickets, projectMap]);

    const recentTasks = useMemo(() => (tickets || []).slice(0, 12), [tickets]);

    const toggleReady = async (t) => {
        const { error } = await setTicketReady(t.ticket_id, !t.status);
        if (error) return alert(error.message);
        loadAll();
    };

    const closeMyTicket = async (t) => {
        const ok = window.confirm("Close this ticket?");
        if (!ok) return;

        const { error } = await closeTicket(t.ticket_id);
        if (error) return alert(error.message);
        loadAll();
    };
    const openCreateModal = () => {
        setEditingTicket(null);
        setShowTaskModal(true);
    };

    // ✅ Edit modal open
    const openEditModal = (t) => {
        setEditingTicket(t);
        setShowTaskModal(true);
    };

    return (
        <div className="tk-container">
            <div className="tk-header">
                <h2 className="tk-title">Tickets</h2>

                {isAdmin && (
                    <button className="tk-assign-btn" onClick={() => setShowTaskModal(true)}>
                        Task
                    </button>
                )}
            </div>

            {loading ? (
                <p>Loading...</p>
            ) : (
                <>
                    <div className="tk-cards">
                        {projectCards.length === 0 ? (
                            <div className="tk-empty">No tasks found.</div>
                        ) : (
                            projectCards.map((c) => (
                                <div className="tk-card" key={c.projectId}>
                                    <div className="tk-card-title">{c.projectName}</div>

                                    <div className="tk-stats">
                                        <div className="tk-row">
                                            <span className="tk-label">Total Task</span>
                                            <span className="tk-value">{c.total}</span>
                                        </div>
                                        <div className="tk-row">
                                            <span className="tk-label">Complete Task</span>
                                            <span className="tk-value green">{c.completed}</span>
                                        </div>
                                        <div className="tk-row">
                                            <span className="tk-label">Pending Task</span>
                                            <span className="tk-value orange">{c.pending}</span>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>

                    <div className="tk-list-section">
                        <div className="tk-list-header">
                            <span className="tk-list-title">{isAdmin ? "Recent Tasks" : "My Tasks"}</span>
                        </div>

                        {recentTasks.length === 0 ? (
                            <div className="tk-empty">No tasks found.</div>
                        ) : (
                            <div className="tk-task-list">
                                {recentTasks.map((t) => {
                                    const projectName = projectMap[t.project_id]?.name || "-";
                                    const dateStr = t.created_at
                                        ? new Date(t.created_at).toLocaleDateString()
                                        : "-";

                                    return (
                                        <div
                                            className="tk-task-card"
                                            key={t.ticket_id}
                                            onClick={() => openDetailsModal(t)}
                                        >
                                            <div className="tk-task-left">
                                                <div className="tk-task-name">{t.title}</div>

                                                {/* ✅ REQUIRED: show ticket id for PR automation */}
                                                <div className="tk-task-sub">
                                                    TASK-{t.ticket_id} • {projectName} • {dateStr}
                                                    {t.file_name ? ` • File: ${t.file_name}` : ""}
                                                </div>
                                            </div>

                                            <div className="tk-task-right">
                                                {isAdmin && !t.is_closed && (
                                                    <button className="tk-mini-btn" onClick={(e) => {
                                                        e.stopPropagation();
                                                        openEditModal(t);
                                                    }}>
                                                        ✏️
                                                    </button>
                                                )}
                                                <span className={`tk-status ${t.status ? "ready" : "notready"}`}>
                                                    {t.status ? "True" : "False"}
                                                </span>

                                                {t.is_closed && <span className="tk-status closed">Closed</span>}

                                                {isAdmin && !t.is_closed && (
                                                    <button className="tk-mini-btn" onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleReady(t);
                                                    }}>
                                                        {t.status ? "Disable" : "Enable"}
                                                    </button>
                                                )}

                                                {!isAdmin && t.status === true && !t.is_closed && (
                                                    <button className="tk-mini-btn primary" onClick={(e) => {
                                                        e.stopPropagation();
                                                        closeMyTicket(t);
                                                    }}>
                                                        Close Ticket
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </>
            )}

            {isAdmin && showTaskModal && (
                <TaskModal
                    key={editingTicket ? editingTicket.ticket_id : "new"} 
                    auth={auth}
                    projects={projects}
                    mode={editingTicket ? "edit" : "create"}
                    ticket={editingTicket}
                    onClose={() => {
                        setShowTaskModal(false);
                        setEditingTicket(null);
                    }}
                    onSaved={() => {
                        setShowTaskModal(false);
                        setEditingTicket(null);
                        loadAll();
                    }}
                />
            )}

            {showDetailsModal && (
                <TaskDetailsModal
                    ticket={viewingTicket}
                    projectName={projectMap[viewingTicket?.project_id]?.name || "-"}
                    onClose={() => {
                        setShowDetailsModal(false);
                        setViewingTicket(null);
                    }}
                />
            )}
        </div>
    );
}